import  { useState, useEffect } from 'react';
import { Button, Form, Row, Col, Card, Alert, Accordion, Badge, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { FaPlus, FaSpinner, FaTimes } from "react-icons/fa";
import faqAreasService from "../../api/faq/faqAreasService";
import programaFaqConfigService from "../../api/faq/programaFaqConfigService";

export default function ProgramaFAQConfig({ programaId }) {
  const [config, setConfig] = useState(null);
  const [emails, setEmails] = useState(['']);
  const [areaConfigs, setAreaConfigs] = useState({});
  const [faqAreas, setFaqAreas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSave, setLoadingSave] = useState(false);
  const [error, setError] = useState('');

  // Modal State
  const [showModal, setShowModal] = useState(false);
  const [currentAreaId, setCurrentAreaId] = useState(null);
  const [newEmail, setNewEmail] = useState('');
  const [modalloading, setModalLoading] = useState(false);

  useEffect(() => {
    if (programaId) {
      loadData();
    }
  }, [programaId]);

  const loadData = async () => {
    setLoading(true);
    await Promise.all([fetchAreas(), fetchConfig()]);
    setLoading(false);
  };

  const fetchAreas = async () => {
    try {
        const response = await faqAreasService.getAll({ ativo: true });
        setFaqAreas(response.data.results || []);
    } catch (error) {
        console.error("Erro ao carregar áreas:", error);
    }
  };

  const fetchConfig = async () => {
    // setLoading(true); // Handled by loadData
    setError('');
    try {
      const response = await programaFaqConfigService.getConfig(programaId);
      
      if (!response.data.results.length > 0) {
        setConfig(null);
        setEmails(['']);
        setAreaConfigs({});
  
        return;
      } 

      const cfg = response.data.results[0];
      setConfig(cfg);
      setEmails(cfg.emails_transbordo && cfg.emails_transbordo.length > 0 ? cfg.emails_transbordo : ['']);
      
      const rawAreaConfigs = cfg.configuracao_areas || {};
      const normalizedConfigs = {};
      
      Object.keys(rawAreaConfigs).forEach(key => {
          const val = rawAreaConfigs[key];
          if (Array.isArray(val)) {
              normalizedConfigs[key] = { emails: val, mensagem: '' };
          } else if (typeof val === 'object' && val !== null) {
               normalizedConfigs[key] = { 
                   emails: Array.isArray(val.emails) ? val.emails : [], 
                   mensagem: val.mensagem || '' 
               };
          } else {
               normalizedConfigs[key] = { emails: [], mensagem: '' };
          }
      });
      
      setAreaConfigs(normalizedConfigs); 
    } catch (error) {
      console.error('Erro ao carregar configuração:', error);
      setError('Erro ao carregar configuração. Tente novamente.');
    } finally {
      // setLoading(false);
    }
  };

  const handleAddEmail = () => {
    setEmails([...emails, '']);
  };

  const handleRemoveEmail = (index) => {
    const newEmails = emails.filter((_, i) => i !== index);
    if (newEmails.length === 0) newEmails.push('');
    setEmails(newEmails);
  };

  const handleOpenModal = (areaId) => {
    setCurrentAreaId(areaId);
    setNewEmail('');
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentAreaId(null);
    setNewEmail('');
  };

  const handleAddEmailApi = async () => {
    if (!newEmail || !newEmail.includes('@')) {
        Swal.fire('Atenção', 'Digite um email válido', 'warning');
        return;
    }

    setModalLoading(true);

    setModalLoading(true);

    try {
        const currentConfig = areaConfigs[currentAreaId] || { emails: [], mensagem: '' };
        const currentEmails = currentConfig.emails || [];
        
        if (currentEmails.includes(newEmail)) {
             Swal.fire('Atenção', 'Este email já está na lista', 'warning');
             setModalLoading(false);
             return;
        }

        const updatedEmails = [...currentEmails, newEmail];
        
        const updatedConfigForArea = { ...currentConfig, emails: updatedEmails };
        
        const updatedAreaConfigs = { ...areaConfigs, [currentAreaId]: updatedConfigForArea };

        const payload = {
            programa_id: programaId,
            emails_transbordo: emails.filter(e => e.trim() !== ''),
            configuracao_areas: updatedAreaConfigs,
            ativo: true
        };

        if (config && config.id) {
            await programaFaqConfigService.update(config.id, payload);
        } else {
           const response = await programaFaqConfigService.create(payload);
           // If it was a new config, we might need to update local 'config' state with ID for future updates
           setConfig(response.data); 
        }

        setAreaConfigs(updatedAreaConfigs);
        handleCloseModal();
        
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            // toast: true,
            // position: 'top-end',
            icon: 'success',
            title: 'Email adicionado',
            showConfirmButton: false,
            timer: 1500
        });

    } catch (error) {
        console.error("Erro ao adicionar email:", error);
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: 'Erro',
            text: 'Não foi possível adicionar o email.',
            icon: 'error',
            showCloseButton: true,
        });
    } finally {
        setModalLoading(false);
    }
  };


  const handleRemoveEmailApi = async (areaId, emailToRemove) => {
    try {
        const MySwal = withReactContent(Swal);
        const result = await MySwal.fire({
            title: 'Remover email?',
            text: `Deseja remover ${emailToRemove} desta área?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, remover',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        const currentConfig = areaConfigs[areaId] || { emails: [], mensagem: '' };
        const currentEmails = currentConfig.emails || [];
        const updatedEmails = currentEmails.filter(e => e !== emailToRemove);
        
        const updatedConfigForArea = { ...currentConfig, emails: updatedEmails };
        const updatedAreaConfigs = { ...areaConfigs, [areaId]: updatedConfigForArea };

        const payload = {
            programa_id: programaId,
            emails_transbordo: emails.filter(e => e.trim() !== ''),
            configuracao_areas: updatedAreaConfigs,
            ativo: true
        };

        if (config && config.id) {
            await programaFaqConfigService.update(config.id, payload);
        } else {
             const response = await programaFaqConfigService.create(payload);
             setConfig(response.data);
        }

        setAreaConfigs(updatedAreaConfigs);
        
        MySwal.fire({
            // toast: true,
            // position: 'top-end',
            icon: 'success',
            title: 'Email removido',
            showConfirmButton: false,
            timer: 1500
        });

    } catch (error) {
        console.error("Erro ao remover email:", error);
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: 'Erro',
            text: 'Não foi possível remover o email.',
            icon: 'error',
            showCloseButton: true,
        });
    }
  };

  const handleMessageChange = (areaId, newMsg) => {
       const currentConfig = areaConfigs[areaId] || { emails: [], mensagem: '' };
       const updatedConfigForArea = { ...currentConfig, mensagem: newMsg };
       setAreaConfigs({ ...areaConfigs, [areaId]: updatedConfigForArea });
  };
  
  const handleSaveMessage = async (areaId) => {
        try {
            const payload = {
                programa_id: programaId,
                emails_transbordo: emails.filter(e => e.trim() !== ''),
                configuracao_areas: areaConfigs,
                ativo: true
            };

            if (config && config.id) {
                await programaFaqConfigService.update(config.id, payload);
            } else {
                const response = await programaFaqConfigService.create(payload);
                setConfig(response.data);
            }
            
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                title: <p>Mensagem atualizada com sucesso!</p>,
                icon: 'success',
                showCloseButton: true,
            });
            
        } catch (error) {
             console.error("Erro ao salvar mensagem:", error);
             const MySwal = withReactContent(Swal);
             MySwal.fire({
                 title: 'Erro',
                 text: 'Erro ao salvar mensagem.',
                 icon: 'error',
                 showCloseButton: true,
             });
        }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingSave(true);
    try {
      const payload = {
        programa_id: programaId,
        emails_transbordo: emails.filter(e => e.trim() !== ''),
        configuracao_areas: areaConfigs,
        ativo: true
      };

      if (config && config.id) {
        await programaFaqConfigService.update(config.id, payload);
      } else {
        await programaFaqConfigService.create(payload);
      }

      const MySwal = withReactContent(Swal);
      MySwal.fire({
          title: <p>Configuração salva com sucesso!</p>,
          icon: 'success',
          showCloseButton: true,
      });

      fetchConfig();
    } catch (error) {
       console.error('Erro ao salvar:', error);
       const MySwal = withReactContent(Swal);
       MySwal.fire({
           title: 'Erro',
           text: 'Erro ao salvar configuração.',
           icon: 'error',
           showCloseButton: true,
       });
    } finally {
      setLoadingSave(false);
    }
  };

  if (loading) {
      return (
          <div className="text-center p-5">
              <FaSpinner className="spinner-rotate" size={24} />
              <div className="mt-2">Carregando configuração...</div>
          </div>
      );
  }

  return (
    <Card className="cardDestaque border-0 shadow-none">
      <Card.Body>


        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={handleSubmit}>
          <h5 className="mb-3">Configuração por Área de FAQ</h5>
          <Form.Text className="text-muted d-block mb-3">
            Defina emails específicos para cada área. Os emails serão notificados quando uma dúvida for enviada para a respectiva área.
          </Form.Text>

            <Accordion defaultActiveKey="0" className="mb-4">
                {faqAreas.map((area, index) => {
                    const configArea = areaConfigs[area.id] || { emails: [], mensagem: '' };
                    const areaEmails = configArea.emails || [];
                    const areaMsg = configArea.mensagem || '';
                    
                    return (
                        <Accordion.Item eventKey={String(index)} key={area.id}>
                            <Accordion.Header>
                                <span className="fw-bold">{area.nome}</span>
                                {areaEmails.length > 0 && (
                                    <Badge bg="info" className="ms-2">
                                        {areaEmails.length} email{areaEmails.length > 1 ? 's' : ''}
                                    </Badge>
                                )}
                            </Accordion.Header>
                            <Accordion.Body>
                                <h6 className="text-muted mb-2">Emails de Transbordo</h6>
                                <div className="d-flex flex-wrap gap-2 mb-3">
                                    {areaEmails.length > 0 ? (
                                        areaEmails.map((email, idx) => (
                                            <Badge key={idx} bg="light" text="dark" className="border p-2 d-flex align-items-center">
                                                <span className="me-2 text-body" style={{ fontSize: '0.9rem' }}>{email}</span>
                                                <FaTimes 
                                                    className="text-danger cursor-pointer" 
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleRemoveEmailApi(area.id, email)}
                                                    title="Remover"
                                                />
                                            </Badge>
                                        ))
                                    ) : (
                                        <p className="text-muted fst-italic mb-0 small">Nenhum email configurado.</p>
                                    )}
                                </div>
                                
                                <Button variant="outline-primary" size="sm" onClick={() => handleOpenModal(area.id)} className="mb-4">
                                    <FaPlus className="me-1" /> Adicionar Email
                                </Button>
                                
                                <hr />
                                
                                <Form.Group>
                                    <Form.Label className="fw-bold text-muted small">Mensagem de Transbordo</Form.Label>
                                    <Row>
                                        <Col>
                                             <Form.Control
                                                as="textarea"
                                                rows={2}
                                                size="sm"
                                                value={areaMsg}
                                                onChange={(e) => handleMessageChange(area.id, e.target.value)}
                                                placeholder="Mensagem específica para esta área..."
                                            />
                                        </Col>
                                        <Col xs="auto" className="d-flex align-items-end">
                                            <Button variant="success" size="sm" onClick={() => handleSaveMessage(area.id)}>
                                                Salvar Msg
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </Accordion.Body>
                        </Accordion.Item>
                    );
                })}
            </Accordion>
            
            {faqAreas.length === 0 && <p className="text-muted">Nenhuma área de FAQ ativa encontrada.</p>}

            <hr />


        </Form>
      </Card.Body>

        {/* Modal Add Email */}
        <Modal show={showModal} onHide={handleCloseModal} centered>
            <Modal.Header closeButton>
                <Modal.Title>Adicionar Email</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label>Email</Form.Label>
                    <Form.Control 
                        type="email" 
                        placeholder="nome@exemplo.com"
                        value={newEmail}
                        onChange={(e) => setNewEmail(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleAddEmailApi();
                            }
                        }}
                        autoFocus
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>Cancelar</Button>
                <Button variant="success" onClick={handleAddEmailApi} disabled={modalloading}>
                    {modalloading ? <FaSpinner className="spinner-rotate" /> : 'Adicionar'}
                </Button>
            </Modal.Footer>
        </Modal>

    </Card>
  );
}
